module.exports = __webpack_public_path__ + "static/media/admin_canvas_thread_icon.9f978dd7.svg";